/* eslint-disable no-await-in-loop */
/* eslint-disable no-restricted-syntax */
import { createAction } from "redux-actions";
import get from "lodash.get";
import { saveAs } from "file-saver";
import { notification } from "antd";

import * as globalTypes from "../../actions/types";
import { fetchLoadsByParams } from "../Loads/actions";
import history from "../../history";
import { subscribeOnChannel } from "../../actions/centrifuge";
import FileService from "../../services/FileService";
import FILE_TYPES from "../../utils/fileEnums";
import { fetchIncidentsByParams } from "../Incidents/actions";
import { formatHash } from "../../utils/stringFormatter";
import { getFileExtension } from "../../utils/fileUtils";
import MapboxService from "../../services/MapboxService";
import { updateLoadListAll } from "../Loads2/actions";
import NewFleetServices from "../NewFleet/service";
import {
  getUrlSearchParams,
  resourcerPrivateParse,
} from "../../utils/urlParser";
import { getFiltersFromUrl } from "../Pendings/utils";
import { getAllPendings } from "../Pendings/actions";
import {
  fetchAllCachedLoadsWithSortDirection,
  fetchAllCount,
} from "../NewLoads/actions";
import { formatPayloadBySearchAdvanced } from "../NewLoads/utils";
import { clearReportProgress } from "../../actions/application";
import { CommunicationService } from "../../services/CommunicationService";

import LoadDetailsService, {
  getVehicleGroupApiErrorMessage,
  isVehicleGroupResponse,
} from "./service";
import * as types from "./actionTypes";
import { handleGetFiltersFromUrl } from "../../utils/filterUtils";

const targetType = "TRANSPORTER";

// Compatibility export: some files import `fetchLoads` from LoadsDetails module.
export { fetchLoadsByParams as fetchLoads } from "../Loads/actions";

export const getIncidentsImages =
  (path, occurrences, hashId) => (dispatch, state) => {
    dispatch(createAction(globalTypes.IS_APPLICATION_LOADING)(false));
    if (path) {
      FileService.download(path)
        .then((result) => {
          const stateIncidents =
            state().loadsDetails.mappedLoadsDetailsByHash[formatHash(hashId)]
              .incidents;
          const localOccurrences = stateIncidents || occurrences;

          dispatch(createAction(globalTypes.IS_APPLICATION_LOADING)(false));
          const newOccurrences = localOccurrences.map((item) => {
            if (item.attachment === path) {
              return {
                ...item,
                serverPath: result,
              };
            }
            return item;
          });
          dispatch(
            createAction(types.FETCH_INCIDENT_IMAGE)({
              hashId,
              incidents: newOccurrences,
            }),
          );
        })
        .catch(() =>
          dispatch(createAction(globalTypes.IS_APPLICATION_LOADING)(false)),
        );
    }
  };

export const fetchLoadNegotiations = (hashId) => (dispatch, state) => {
  dispatch(createAction(globalTypes.IS_APPLICATION_LOADING)(true));
  LoadDetailsService.fetchLoadNegotiations(hashId)
    .then((result) => {
      const currentLoad = get(
        state(),
        `loadsDetails.mappedLoadsDetailsByHash[${formatHash(hashId)}]`,
        null,
      );
      let negotiations = [
        {
          agent: "SHIPPER",
          date: currentLoad.launchDate,
          firstPurpose: true,
          value: currentLoad.freightPrice,
        },
      ];

      if (result?.itens?.length) {
        negotiations = [...negotiations, ...result.itens.slice().reverse()]
      }
      dispatch(
        createAction(types.FETCH_LOAD_NEGOTIATIONS)({
          hashId,
          data: negotiations,
          negotiationStatus: result && result.status,
          estimatedDate: result && result.estimatedDate,
          percentMargin: result && result.percentMargin,
          negotiationConfig: result && result.negotiationConfig,
          negotiationParts: result && result.negotiationParts,
          proposalValues: {
            proposalWithLowerValue: result && result.proposalWithLowerValue,
            percentageDifferenceWithLowerProposal:
              result && result.percentageDifferenceWithLowerProposal,
            minimunByTransporter: result && result.minimunByTransporter,
          },
          flShowOtherPrices: result && result.flShowOtherPrices,
        }),
      );
    })
    .catch((err) => {
      dispatch(createAction(globalTypes.IS_APPLICATION_LOADING)(false));
      console.log(err);
    })
    .finally(() =>
      dispatch(createAction(globalTypes.IS_APPLICATION_LOADING)(false)),
    );
};

export const newPendingUpdate = (type) => (dispatch) => {
  dispatch(
    createAction(types.NEW_PENDING_UPDATE)(
      type ? { moment: Date.now(), type } : { moment: null, type: null },
    ),
  );
};

export const fetchLoadHistory = (hashId, deliveryId) => (dispatch) => {
  dispatch(createAction(globalTypes.IS_APPLICATION_LOADING)(true));
  LoadDetailsService.fetchLoadHistory(hashId, deliveryId)
    .then((result) => {
      dispatch(
        createAction(types.FETCH_LOAD_HISTORY)({
          hashId,
          history: result,
        }),
      );
      dispatch(createAction(globalTypes.IS_APPLICATION_LOADING)(false));
    })
    .catch((err) => {
      dispatch(createAction(globalTypes.IS_APPLICATION_LOADING)(false));
      console.log(err);
    });
};

export const fetchLoadBids = (hashId) => (dispatch) => {
  dispatch(createAction(globalTypes.IS_APPLICATION_LOADING)(true));
  LoadDetailsService.fetchLoadBids(hashId)
    .then((result) => {
      dispatch(createAction(globalTypes.IS_APPLICATION_LOADING)(false));
      dispatch(createAction(types.FETCH_LOAD_BIDS)({ hashId, data: result }));
    })
    .catch((err) => {
      dispatch(createAction(globalTypes.IS_APPLICATION_LOADING)(false));
      console.log(err);
    });
};

export const fetchLoadIncidents = (hashId, deliveryId) => (dispatch) => {
  console.log(hashId);
  dispatch(createAction(globalTypes.IS_APPLICATION_LOADING)(true));
  LoadDetailsService.fetchLoadIncidents(deliveryId)
    .then((result) => {
      dispatch(
        createAction(types.FETCH_LOAD_INCIDENTS)({
          hashId,
          incidents: result,
        }),
      );
      if (result && result.length) {
        result.map((item) =>
          dispatch(getIncidentsImages(item.attachment, result, hashId)),
        );
      }
      dispatch(createAction(globalTypes.IS_APPLICATION_LOADING)(false));
    })
    .catch((err) => {
      dispatch(createAction(globalTypes.IS_APPLICATION_LOADING)(false));
      console.log(err);
    });
};

export const downloadLoadAttachmentFiles =
  (files = [], attachmentId) =>
  (dispatch, state) => {
    dispatch(createAction(types.CLEAR_LOAD_FILES_BY_ATTACHMENT)(attachmentId));
    dispatch(createAction(globalTypes.IS_APPLICATION_LOADING)(true));

    const downloadPromises = files.map((path) =>
      FileService.downloadFile(path)
        .then((result) => {
          const fileTypeIdx = path.lastIndexOf(".");
          const fileType = path.slice(fileTypeIdx);

          const file = {
            preview: result,
            type: fileType,
            name: path.slice(path.lastIndexOf("/") + 1),
          };

          return file;
        })
        .catch(() => null),
    );

    Promise.all(downloadPromises)
      .then((downloadedFiles) => {
        const validFiles = downloadedFiles.filter((file) => file !== null);

        dispatch(
          createAction(types.FETCH_LOAD_FILES_BY_ATTACHMENT)({
            files: validFiles,
            attachmentId,
          }),
        );
      })
      .catch((error) => {
        console.error("Erro ao baixar arquivos:", error);
      })
      .finally(() =>
        dispatch(createAction(globalTypes.IS_APPLICATION_LOADING)(false)),
      );
  };

export const fetchLoadAttachments = (hashId, deliveryId) => (dispatch) => {
  dispatch(createAction(globalTypes.IS_APPLICATION_LOADING)(true));
  LoadDetailsService.fetchLoadAttachments(hashId, deliveryId)
    .then((result) => {
      dispatch(
        createAction(types.FETCH_LOAD_ATTACHMENTS)({
          attachments: result,
          hashId,
        }),
      );
      if (result && result.length) {
        result.forEach((item) =>
          dispatch(downloadLoadAttachmentFiles(item.attachments, item.id)),
        );
      }
      dispatch(createAction(globalTypes.IS_APPLICATION_LOADING)(false));
    })
    .catch((err) => {
      dispatch(createAction(globalTypes.IS_APPLICATION_LOADING)(false));
      console.log(err);
    });
};
export const fetchItnerary = (deliveryId, hashId) => (dispatch) => {
  LoadDetailsService.fetchTrackerOptions(deliveryId)
    .then((res) => {
      dispatch(
        createAction(types.FETCH_LOAD_ITNERARY)({
          itnerary: res.locations,
          hashId,
          options: res,
        }),
      );
    })
    .catch((err) => {
      console.log(err);
    });
};
export const fetchLoadById = (hashId, deliveryId) => (dispatch) => {
  if (!hashId) return;
  dispatch(createAction(globalTypes.IS_APPLICATION_LOADING)(true));
  LoadDetailsService.fetchLoadDetailsById(hashId, deliveryId)
    .then((result) => {
      const fakeLoad = {
        hashId,
        ...result,
        statusDelivery:
          result.statusDelivery === "ASSIGNED_TO_TRANSPORTER" && result.driver
            ? "WAITING_DRIVER_ACCEPT"
            : result.statusDelivery,
        lastUpdatedAt: new Date(),
      };
      const batchStatusDelivery = get(
        get(result, "deliveries", []).filter(
          (item) => item.id === result.deliveryId,
        )[0],
        "status",
        null,
      );
      const batchDriver = get(
        get(result, "deliveries", []).filter(
          (item) => item.id === result.deliveryId,
        )[0],
        "driver",
        null,
      );
      if (
        result.deliveryType &&
        result.deliveryType.toLowerCase() === "lot" &&
        batchStatusDelivery
      ) {
        fakeLoad.statusDelivery =
          batchStatusDelivery === "ASSIGNED_TO_TRANSPORTER" && batchDriver
            ? "WAITING_DRIVER_ACCEPT"
            : batchStatusDelivery;
      }
      if (
        result.deliveryType &&
        result.deliveryType.toLowerCase() === "lot" &&
        batchDriver
      ) {
        fakeLoad.driver = {
          ...batchDriver,
        };
      }
      if (result.statusDelivery) {
        dispatch(fetchLoadIncidents(hashId, result.deliveryId));
        if (history.location.pathname.includes("/incidents")) {
          dispatch(fetchIncidentsByParams({}));
        }
      }
      if (
        result.status === "WAIT_TRANSPORTER_ACCEPT" &&
        result.type === "AUCTION"
      ) {
        dispatch(subscribeOnChannel(hashId));
      }
      dispatch(fetchLoadAttachments(hashId, deliveryId));
      dispatch(createAction(types.FETCH_LOAD_DETAILS)(fakeLoad));
      if (deliveryId) {
        dispatch(fetchItnerary(deliveryId, hashId));
      }
      if (
        result.status === "IN_DELIVERY" ||
        result.status === "FINISHED" ||
        (result.deliveryType === "LOT" && deliveryId)
      ) {
        const isLot = result.deliveryType === "LOT";
        const deliveryIdInner = isLot
          ? result.deliveryId
          : get(result, "deliveries[0].id", result.deliveryId);
        dispatch(fetchLoadHistory(hashId, deliveryIdInner, isLot));
      }

      if (result.type.toLowerCase() === "auction") {
        dispatch(fetchLoadBids(hashId));
      }
      if (result.status === "NEGOTIATION") {
        dispatch(fetchLoadNegotiations(hashId));
      }
      if (
        result.status === "WAIT_TRANSPORTER_ACCEPT" ||
        result.status === "WAITING_APPROVE"
      ) {
        if (result.type.toLowerCase() !== "auction") {
          dispatch(fetchLoadNegotiations(hashId));
        }
      }
      dispatch(createAction(globalTypes.IS_APPLICATION_LOADING)(false));
    })
    .catch((err) => {
      dispatch(createAction(globalTypes.IS_APPLICATION_LOADING)(false));
      console.log(err);
    });
};

export const makeProposal =
  (value, hashId, estimatedDate, proposalJustification) => (dispatch) => {
    dispatch(createAction(globalTypes.IS_APPLICATION_LOADING)(true));
    LoadDetailsService.sendNewProposal(
      hashId,
      value,
      estimatedDate,
      proposalJustification,
    )
      .then(() => {
        dispatch(fetchLoadNegotiations(hashId));
        dispatch(createAction(globalTypes.IS_APPLICATION_LOADING)(false));
        return dispatch(
          createAction(globalTypes.SHOW_USER_FEEDBACK)({
            feedbackMessage: "Proposta enviada.",
            feedbackTitle: null,
            feedbackType: "MESSAGE",
            styleFeedbackType: "success",
            messageTimestamp: new Date().getTime(),
          }),
        );
      })
      .catch((err) => {
        dispatch(createAction(globalTypes.IS_APPLICATION_LOADING)(false));
        console.log(err);
      });
  };

export const makeProposalByVehicleType = (hashId, payload) => (dispatch) => {
  dispatch(createAction(globalTypes.IS_APPLICATION_LOADING)(true));
  LoadDetailsService.sendNewProposalByVehicleType(hashId, payload)
    .then(() => {
      dispatch(fetchLoadNegotiations(hashId));
      dispatch(createAction(globalTypes.IS_APPLICATION_LOADING)(false));
      return dispatch(
        createAction(globalTypes.SHOW_USER_FEEDBACK)({
          feedbackMessage: "Proposta enviada.",
          feedbackTitle: null,
          feedbackType: "MESSAGE",
          styleFeedbackType: "success",
          messageTimestamp: new Date().getTime(),
        }),
      );
    })
    .catch((err) => {
      dispatch(createAction(globalTypes.IS_APPLICATION_LOADING)(false));
      console.log(err);
    });
};

export const sendRequestWithoutTracking =
  (payload, closeModal) => (dispatch) => {
    dispatch(createAction(globalTypes.IS_APPLICATION_LOADING)(true));
    LoadDetailsService.requestWithoutTracking(payload)
      .then((res) => {
        dispatch(fetchLoadById(payload.hashId, payload.deliveryId));
        dispatch(fetchItnerary(payload.deliveryId, payload.hashId));
        if (closeModal) {
          closeModal();
        }
      })
      .catch((err) => console.log(err))
      .finally(() =>
        dispatch(createAction(globalTypes.IS_APPLICATION_LOADING)(false)),
      );
  };

export const acceptLoad =
  (hashId, refreshLoads, possibleFreightPriceId) => (dispatch) => {
    dispatch(createAction(globalTypes.IS_APPLICATION_LOADING)(true));
    LoadDetailsService.acceptLoad(hashId, possibleFreightPriceId)
      .then((result) => {
        dispatch(createAction(types.LOAD_ACCEPT)(result));
        dispatch(
          createAction(globalTypes.SHOW_USER_FEEDBACK)({
            feedbackMessage: "Aceite de frete enviado.",
            feedbackTitle: null,
            feedbackType: "MESSAGE",
            styleFeedbackType: "success",
            messageTimestamp: new Date().getTime(),
          }),
        );
        if (refreshLoads) {
          dispatch(createAction(globalTypes.IS_APPLICATION_LOADING)(false));
          dispatch(updateLoadListAll(true, true));
        } else {
          dispatch(fetchLoadById(hashId));
          setTimeout(() => {
            dispatch(createAction(globalTypes.IS_APPLICATION_LOADING)(true));
          }, 2000);
          setTimeout(() => {
            dispatch(fetchLoadById(hashId));
          }, 3000);
        }
      })
      .catch((err) => {
        dispatch(createAction(globalTypes.IS_APPLICATION_LOADING)(false));
        console.log(err);
      });
  };

export const findDriverByCpfAtlas = (cpf) => (dispatch) => {
  dispatch(createAction(globalTypes.IS_APPLICATION_LOADING)(true));
  LoadDetailsService.findDriverByCpfAtlas(cpf)
    .then((result) => {
      dispatch(createAction(globalTypes.IS_APPLICATION_LOADING)(false));
      if (result.erroCodigo && result.erro) {
        return dispatch(createAction(types.FIND_DRIVER_BY_NAME_NOT_FOUND)());
      }
      return dispatch(
        createAction(types.FIND_DRIVER_BY_CPF_TO_REGISTER)(result),
      );
    })
    .catch((err) => {
      dispatch(createAction(globalTypes.IS_APPLICATION_LOADING)(false));
      console.log(err);
    });
};

export const findDriverByCpf =
  (cpf, shippingHash, deliveryId) => (dispatch) => {
    dispatch(createAction(types.CLEAR_FOUND_DRIVER)());
    dispatch(createAction(globalTypes.IS_APPLICATION_LOADING)(true));
    LoadDetailsService.findDriverByCpf(cpf, shippingHash, deliveryId)
      .then((result) => {
        dispatch(createAction(globalTypes.IS_APPLICATION_LOADING)(false));
        if (result === null) {
          return dispatch(createAction(types.FIND_DRIVER_BY_NAME_NOT_FOUND)());
          // return dispatch(findDriverByCpfAtlas(cpf))
        }
        return dispatch(createAction(types.FIND_DRIVER_BY_CPF)(result));
      })
      .catch((err) => {
        dispatch(createAction(globalTypes.IS_APPLICATION_LOADING)(false));
      });
  };

export const findDriverByName =
  (name, shippingHash, deliveryId) => (dispatch) => {
    const params = {
      name,
      shippingHash,
      orderColumn: "name",
      orderDirection: "ASC",
      page: 1,
      size: 1000,
      deliveryId,
    };
    dispatch(createAction(globalTypes.IS_APPLICATION_LOADING)(true));
    LoadDetailsService.findDriverByName(params)
      .then((result) => {
        dispatch(createAction(globalTypes.IS_APPLICATION_LOADING)(false));
        if (!result || result.length < 1) {
          // return dispatch(findDriverByCpfAtlas(cpf))
          return dispatch(createAction(types.FIND_DRIVER_BY_NAME_NOT_FOUND)());
        } else if (result && result.length > 1) {
          return dispatch(createAction(types.FIND_DRIVER_BY_NAME)(result));
        }
        return dispatch(createAction(types.FIND_DRIVER_BY_CPF)(result[0]));
      })
      .catch((err) => {
        dispatch(createAction(globalTypes.IS_APPLICATION_LOADING)(false));
      });
  };

export const findVehicleByPlate =
  (plate, shippingHash, deliveryId) => (dispatch) => {
    dispatch(createAction(globalTypes.IS_APPLICATION_LOADING)(true));
    LoadDetailsService.findVehicleByPlate(plate, shippingHash, deliveryId)
      .then((result) => {
        dispatch(createAction(globalTypes.IS_APPLICATION_LOADING)(false));
        if (result && result.length) {
          return dispatch(createAction(types.FIND_VEHICLE_BY_PLATE)(result[0]));
        }
        return dispatch(createAction(types.FIND_VEHICLE_BY_PLATE)("NOT_FOUND"));
      })
      .catch((err) => {
        dispatch(createAction(globalTypes.IS_APPLICATION_LOADING)(false));
      });
  };

export const findVehicleGroupByVehicleIds =
  (vehicleIds, shippingHash, deliveryId) => (dispatch) => {
    dispatch(createAction(globalTypes.IS_APPLICATION_LOADING)(true));
    return LoadDetailsService.findOrRegisterByVehicleIds(vehicleIds, shippingHash, deliveryId)
      .then((result) => {
        dispatch(createAction(globalTypes.IS_APPLICATION_LOADING)(false));
        const vehicleGroup = Array.isArray(result) ? result[0] : result;

        if (!isVehicleGroupResponse(vehicleGroup)) {
          return Promise.reject(
            new Error(getVehicleGroupApiErrorMessage(vehicleGroup)),
          );
        }

        return dispatch(createAction(types.FIND_VEHICLE_BY_PLATE)(vehicleGroup));
      })
      .catch((err) => {
        dispatch(createAction(globalTypes.IS_APPLICATION_LOADING)(false));
        throw err;
      });
  };

export const consultPlateApiInfoSimples =
  (plate, rntrc, vehicleId, deliveryId) => (dispatch) => {
    dispatch(createAction(globalTypes.IS_APPLICATION_LOADING)(true));
    return LoadDetailsService.consultPlateApiInfoSimples(
      plate,
      rntrc,
      vehicleId,
      deliveryId,
    )
      .then((res) => {
        dispatch(createAction(globalTypes.IS_APPLICATION_LOADING)(false));
        if (res.ok) {
          switch (res.data) {
            case "RNTRC_VALID":
              return { status: "SUCCESS" };
            case "CONSULT_FAIL":
              return { status: "FAIL" };
            case "RNTRC_NOT_IN_VEHICLE":
              return {
                status: "ERROR",
                message:
                  "A RNTRC informada não pertence ao veículo selecionado.",
              };
            case "RNTRC_INVALID":
              return {
                status: "ERROR",
                message: "A RNTRC informada é inválida.",
              };
            default:
              dispatch(
                createAction(globalTypes.SHOW_USER_FEEDBACK)({
                  feedbackMessage:
                    "Não foi possível validar o RNTRC no momento. Tente novamente mais tarde.",
                  feedbackTitle: null,
                  feedbackType: "MESSAGE",
                  styleFeedbackType: "error",
                  messageTimestamp: new Date().getTime(),
                }),
              );
              return {
                status: "ERROR",
                message:
                  "Não foi possível validar o RNTRC no momento. Tente novamente mais tarde.",
              };
          }
          return res;
        }
      })
      .catch((err) => {
        dispatch(createAction(globalTypes.IS_APPLICATION_LOADING)(false));
        dispatch(
          createAction(globalTypes.SHOW_USER_FEEDBACK)({
            feedbackMessage:
              "Não foi possível validar o RNTRC no momento. Tente novamente mais tarde.",
            feedbackTitle: null,
            feedbackType: "MESSAGE",
            styleFeedbackType: "error",
            messageTimestamp: new Date().getTime(),
          }),
        );
      })
      .finally(() =>
        dispatch(createAction(globalTypes.IS_APPLICATION_LOADING)(false)),
      );
  };

export const waitForUserConfirmation =
  (deliveryHash, event) => async (dispatch) => {
    try {
      const res = await CommunicationService.findNotification(
        deliveryHash,
        event,
      );

      if (!res.status === 200) {
        throw new Error(res.data);
      }

      if (res.data) {
        return new Promise((resolve) => {
          dispatch(
            createAction(globalTypes.SET_COMMUNICATION_CONTENT)({
              visible: true,
              resolve,
              notification: res.data,
            }),
          );
        });
      }

      return true;
    } catch (err) {
      throw err;
    }
  };

export const bindDriverAndVehicle =
  (
    {
      hashId,
      driverId,
      vehicleId,
      driverPaymentNumber,
      deliveryId,
      flEnableCommunication,
      deliveryHash,
    },
    cb = () => {},
  ) =>
  async (dispatch, getState) => {
    try {
      dispatch(createAction(globalTypes.IS_APPLICATION_LOADING)(true));

      if (flEnableCommunication && deliveryHash) {
        try {
          dispatch(createAction(globalTypes.IS_APPLICATION_LOADING)(false));
          const confirmed = await dispatch(
            waitForUserConfirmation(deliveryHash, "ADD_DRIVER_VEHICLE"),
          );
          if (!confirmed) return;
          dispatch(
            createAction(globalTypes.COMMUNICATION_CONTENT_VISIBLE)(false),
          );
          dispatch(createAction(globalTypes.IS_APPLICATION_LOADING)(true));
        } catch (err) {
          console.error(err);
          dispatch(createAction(globalTypes.IS_APPLICATION_LOADING)(false));
          return;
        }
      }

      const enableSearchFreightByCache =
        get(
          getState(),
          "settings.configs.ENABLE_SEARCH_FREIGHT_BY_CACHE.value",
          "true",
        ) === "true";

      const filters = get(getState(), "newLoads.filters", {});
      const operationIds = get(getState(), "settings.operationGroups", []).map(
        (item) => item.id,
      );

      await LoadDetailsService.bindDriverAndVehicle(
        hashId,
        driverId,
        vehicleId,
        driverPaymentNumber,
        deliveryId,
      );

      cb();
      dispatch(
        createAction(globalTypes.SHOW_USER_FEEDBACK)({
          feedbackMessage: "Motorista e veículo vinculados com sucesso.",
          feedbackTitle: null,
          feedbackType: "MESSAGE",
          styleFeedbackType: "success",
          messageTimestamp: new Date().getTime(),
        }),
      );

      const path = get(history, "location.pathname", "");
      const verify = path.includes("/loads");

      if (path.includes("/details")) {
        await dispatch(fetchLoadById(hashId, deliveryId));
      } else if (path === "/loads/new" || enableSearchFreightByCache) {
        const search = history.location.search;
        const payload = handleGetFiltersFromUrl(search, {
          defaultValues: { operationGroups: operationIds },
          defaultReturnTypes: {
            operationGroups: [],
            searchStatus: [],
            waitingAtLogisticOperator: "boolean",
            flProposalSended: "boolean",
            flShippingNotViewed: "boolean",
            flLotAvailable: "boolean",
          },
        });

        await dispatch(
          fetchAllCachedLoadsWithSortDirection(
            formatPayloadBySearchAdvanced(payload),
          ),
        );
        await dispatch(fetchAllCount(formatPayloadBySearchAdvanced(payload)));
      } else {
        await dispatch(updateLoadListAll(false, true));
      }
    } catch (err) {
      console.error(err);
    } finally {
      dispatch(createAction(globalTypes.IS_APPLICATION_LOADING)(false));
    }
  };

export const pendingBindDriverAndVehicle =
  (
    {
      hashId,
      driverId,
      vehicleId,
      driverPaymentNumber,
      deliveryId,
      flEnableCommunication,
      deliveryHash,
      targetType,
    },
    cb = () => {},
  ) =>
  async (dispatch, getState) => {
    try {
      dispatch(createAction(globalTypes.IS_APPLICATION_LOADING)(true));

      if (flEnableCommunication && deliveryHash) {
        try {
          dispatch(createAction(globalTypes.IS_APPLICATION_LOADING)(false));
          const confirmed = await dispatch(
            waitForUserConfirmation(deliveryHash, "ADD_DRIVER_VEHICLE"),
          );
          if (!confirmed) return;
          dispatch(
            createAction(globalTypes.COMMUNICATION_CONTENT_VISIBLE)(false),
          );
          dispatch(createAction(globalTypes.IS_APPLICATION_LOADING)(true));
        } catch (err) {
          console.error(err);
          dispatch(createAction(globalTypes.IS_APPLICATION_LOADING)(false));
          return;
        }
      }

      await LoadDetailsService.bindDriverAndVehicle(
        hashId,
        driverId,
        vehicleId,
        driverPaymentNumber,
        deliveryId,
      );

      cb();

      dispatch(
        createAction(globalTypes.SHOW_USER_FEEDBACK)({
          feedbackMessage: "Motorista e veículo vinculados com sucesso.",
          feedbackTitle: null,
          feedbackType: "MESSAGE",
          styleFeedbackType: "success",
          messageTimestamp: new Date().getTime(),
        }),
      );

      const path = get(history, "location.pathname", "");
      const search = get(history, "location.search", "");

      if (path.includes("/pendings")) {
        const query = getUrlSearchParams(search);
        const filter = getFiltersFromUrl(query);
        await dispatch(getAllPendings({ ...filter, page: 1, targetType }));
      } else {
        const type = get(getState(), "pendings.pendingModal.type", "");
        const filter =
          type === "DETAIL"
            ? { status: "OPEN", notViewed: true }
            : { status: "OPEN" };
        await dispatch(getAllPendings({ ...filter, page: 1, targetType }));
      }
    } catch (err) {
      console.error(err);
    } finally {
      dispatch(createAction(globalTypes.IS_APPLICATION_LOADING)(false));
    }
  };

export const markPurposesAsRead = (hashId) => (dispatch) => {
  LoadDetailsService.markPurposesAsRead(hashId)
    .catch((err) => {
      console.log(err);
    });
};

export const forceDriverAccept =
  (hashId, driverId, refreshLoads, deliveryId) => (dispatch) => {
    dispatch(createAction(globalTypes.IS_APPLICATION_LOADING)(true));
    LoadDetailsService.forceDriverAccept(hashId, driverId)
      .then((result) => {
        dispatch(createAction(types.LOAD_ACCEPT)(result));
        dispatch(
          createAction(globalTypes.SHOW_USER_FEEDBACK)({
            feedbackMessage: "Motorista vinculado ao frete.",
            feedbackTitle: null,
            feedbackType: "MESSAGE",
            styleFeedbackType: "success",
            messageTimestamp: new Date().getTime(),
          }),
        );
        if (refreshLoads) {
          dispatch(createAction(globalTypes.IS_APPLICATION_LOADING)(false));
          dispatch(
            fetchLoadsByParams({
              status: ["WAIT_TRANSPORTER_ACCEPT", "NEGOTIATION"],
              tab: "market",
              type: ["NORMAL", "AUCTION"],
            }),
          );
        } else {
          // dispatch(fetchLoadById(hashId))
          setTimeout(() => {
            dispatch(createAction(globalTypes.IS_APPLICATION_LOADING)(true));
          }, 2000);
          setTimeout(() => {
            dispatch(fetchLoadById(hashId, deliveryId));
          }, 3000);
        }
      })
      .catch((err) => {
        dispatch(createAction(globalTypes.IS_APPLICATION_LOADING)(false));
        console.log(err);
      });
  };

export const requestForcedAccept =
  (hashId, deliveryId, motive) => (dispatch) => {
    dispatch(createAction(globalTypes.IS_APPLICATION_LOADING)(true));
    LoadDetailsService.requestForcedAccept(hashId, deliveryId, motive)
      .then((result) => {
        dispatch(createAction(types.LOAD_ACCEPT)(result));
        dispatch(
          createAction(globalTypes.SHOW_USER_FEEDBACK)({
            feedbackMessage: "Solicitação enviada com sucesso.",
            feedbackTitle: null,
            feedbackType: "MESSAGE",
            styleFeedbackType: "success",
            messageTimestamp: new Date().getTime(),
          }),
        );
        setTimeout(() => {
          dispatch(fetchLoadById(hashId, deliveryId));
        }, 3000);
      })
      .catch((err) => {
        dispatch(createAction(globalTypes.IS_APPLICATION_LOADING)(false));
        console.log(err);
      });
  };

export const placeBid = (hashId, bid) => (dispatch) => {
  dispatch(createAction(globalTypes.IS_APPLICATION_LOADING)(true));
  LoadDetailsService.placeBid(hashId, bid)
    .then(() => {
      dispatch(createAction(globalTypes.IS_APPLICATION_LOADING)(false));
      dispatch(
        createAction(globalTypes.SHOW_USER_FEEDBACK)({
          feedbackMessage: "Lance enviado com sucesso.",
          feedbackTitle: null,
          feedbackType: "MESSAGE",
          styleFeedbackType: "success",
          messageTimestamp: new Date().getTime(),
        }),
      );
      // dispatch(fetchLoadBids(hashId))
    })
    .catch((err) => {
      dispatch(createAction(globalTypes.IS_APPLICATION_LOADING)(false));
      console.log(err);
    });
};

export const openIncident = (occurrence, hashId) => (dispatch) => {
  dispatch(createAction(globalTypes.IS_APPLICATION_LOADING)(true));
  LoadDetailsService.openIncident(occurrence)
    .then(() => {
      dispatch(fetchLoadIncidents(hashId, occurrence.shippingDeliveryId));
    })
    .catch((err) => {
      dispatch(createAction(globalTypes.IS_APPLICATION_LOADING)(false));
      console.log(err);
    });
};

export const saveOccurrence =
  (file, deliveryId, typeId, obs, hashId) => (dispatch) => {
    if (file) {
      dispatch(createAction(globalTypes.IS_APPLICATION_LOADING)(true));
      return FileService.upload(file, FILE_TYPES.shipping.occurrence)
        .then((result) => {
          const newOccurrence = {
            attachment: result,
            observation: obs,
            occurrenceTypeId: typeId,
            shippingDeliveryId: deliveryId,
          };
          return dispatch(openIncident(newOccurrence, hashId));
        })
        .catch((err) => {
          console.log(err);
        })
        .finally(() =>
          dispatch(createAction(globalTypes.IS_APPLICATION_LOADING)(false)),
        );
    }

    const newOccurrence = {
      attachment: "",
      observation: obs,
      occurrenceTypeId: typeId,
      shippingDeliveryId: deliveryId,
    };
    return dispatch(openIncident(newOccurrence, hashId));
  };

export const closeIncident =
  (incidentId, observation, hashId, deliveryId, status) => (dispatch) => {
    dispatch(createAction(globalTypes.IS_APPLICATION_LOADING)(true));
    LoadDetailsService.closeIncident(incidentId, observation)
      .then(() => {
        dispatch(fetchIncidentsByParams(1, status));
        // dispatch(fetchLoadIncidents(hashId))
        if (deliveryId) {
          dispatch(fetchLoadIncidents(hashId, deliveryId));
        }
      })
      .catch((err) => {
        dispatch(createAction(globalTypes.IS_APPLICATION_LOADING)(false));
        console.log(err);
      });
  };
export const forwardIncident =
  (incidentId, observation, hashId, deliveryId, status) => (dispatch) => {
    dispatch(createAction(globalTypes.IS_APPLICATION_LOADING)(true));
    LoadDetailsService.forwardIncident(incidentId, observation)
      .then(() => {
        dispatch(
          createAction(globalTypes.SHOW_USER_FEEDBACK)({
            feedbackMessage:
              "Ocorrência encaminhada para embarcador responsável.",
            feedbackTitle: null,
            feedbackType: "MESSAGE",
            styleFeedbackType: "success",
            messageTimestamp: new Date().getTime(),
          }),
        );
        if (deliveryId) {
          dispatch(fetchLoadIncidents(hashId, deliveryId));
        }
        dispatch(fetchIncidentsByParams(1, status));
      })
      .catch((err) => {
        dispatch(createAction(globalTypes.IS_APPLICATION_LOADING)(false));
        console.log(err);
      });
  };

export const batchWithdraw = (hashId, amount, lotAgreementId) => (dispatch) => {
  dispatch(createAction(globalTypes.IS_APPLICATION_LOADING)(true));
  return LoadDetailsService.batchWithdraw(hashId, amount, lotAgreementId)
    .then(() => {
      dispatch(fetchLoadById(hashId));
    })
    .catch((err) => {
      dispatch(createAction(globalTypes.IS_APPLICATION_LOADING)(false));
      console.log(err);
    });
};
export const updateWithdraw = (payload) => (dispatch) => {
  dispatch(createAction(globalTypes.IS_APPLICATION_LOADING)(true));
  LoadDetailsService.updateWithdraw(payload)
    .then(() => {
      dispatch(fetchLoadById(payload.hashId));
    })
    .catch((err) => {
      console.log(err);
    })
    .finally(() =>
      dispatch(createAction(globalTypes.IS_APPLICATION_LOADING)(false)),
    );
};
export const confirmDeliveryWithImages =
  (deliveryId, hashId, deliveries, refreshLoads) => (dispatch) => {
    const payload = {
      deliveryId,
      itens: [
        ...deliveries.map((item) => ({
          destinationId: item.destinationId,
          observation: item.observation,
          receiptImage: item.receiptImage,
          deliveryDate: item.efectiveDeliveryDate || undefined,
        })),
      ],
    };
    LoadDetailsService.closeLoadByTransporter(hashId, payload)
      .then(() => {
        dispatch(createAction(globalTypes.IS_APPLICATION_LOADING)(false));
        if (refreshLoads) {
          dispatch(fetchLoadsByParams({ tab: "my" }));
        } else {
          dispatch(fetchLoadById(hashId));
        }
        return dispatch(
          createAction(globalTypes.SHOW_USER_FEEDBACK)({
            feedbackMessage: "Comprovate(s) enviado(s), entrega finalizada.",
            feedbackTitle: null,
            feedbackType: "MESSAGE",
            styleFeedbackType: "success",
            messageTimestamp: new Date().getTime(),
          }),
        );
      })
      .catch((err) => {
        dispatch(createAction(globalTypes.IS_APPLICATION_LOADING)(false));
        console.log(err);
      });
  };

export const closeLoadByTransporter = ({ hashId, payload }) =>
  LoadDetailsService.closeLoadByTransporter(hashId, payload);

export const pendingConfirmDeliveryWithImages =
  (deliveryId, hashId, deliveries, cb) => (dispatch, state) => {
    const payload = {
      deliveryId,
      itens: [
        ...deliveries.map((item) => ({
          destinationId: item.destinationId,
          observation: item.observation,
          receiptImage: item.receiptImage,
          deliveryDate: item.efectiveDeliveryDate || undefined,
        })),
      ],
    };
    closeLoadByTransporter({ hashId, payload })
      .then(() => {
        dispatch(createAction(globalTypes.IS_APPLICATION_LOADING)(false));
        cb();
        const path = get(history, "location.pathname", "");
        const search = get(history, "location.pathname", "");
        if (path.includes("/pendings")) {
          const query = getUrlSearchParams(search);
          const filter = getFiltersFromUrl(query);
          dispatch(getAllPendings({ ...filter, page: 1, targetType }));
        } else {
          const type = get(state(), "pendings.pendingModal.type", "");
          const filter =
            type === "DETAIL"
              ? { status: "OPEN", notViewed: true }
              : { status: "OPEN" };
          dispatch(getAllPendings({ ...filter, page: 1, targetType }));
        }
        return dispatch(
          createAction(globalTypes.SHOW_USER_FEEDBACK)({
            feedbackMessage: "Comprovate(s) enviado(s), entrega finalizada.",
            feedbackTitle: null,
            feedbackType: "MESSAGE",
            styleFeedbackType: "success",
            messageTimestamp: new Date().getTime(),
          }),
        );
      })
      .catch((err) => {
        dispatch(createAction(globalTypes.IS_APPLICATION_LOADING)(false));
        console.log(err);
      });
  };

export const confirmDelivery =
  (deliveryId, hashId, deliveries = [], refreshLoads) =>
  async (dispatch) => {
    dispatch(createAction(globalTypes.IS_APPLICATION_LOADING)(true));
    const uploadPromises = [];

    const newDeliveries = [
      ...deliveries.map((item) => ({
        ...item,
        receiptImage: [],
        destinationId: item.id,
        deliveryDate: item.deliveryDate || undefined,
      })),
    ];
    deliveries.forEach((item, deliveryIndex) => {
      item.pictures.forEach((picture) => {
        const uploadPromise = FileService.upload(
          picture,
          FILE_TYPES.shipping.receipt,
        ).then((result) => {
          newDeliveries[deliveryIndex].receiptImage.push(result);
        });
        uploadPromises.push(uploadPromise);
      });
    });

    await Promise.all(uploadPromises);

    dispatch(
      confirmDeliveryWithImages(
        deliveryId,
        hashId,
        newDeliveries,
        refreshLoads,
      ),
    );
  };

export const pendingConfirmDelivery =
  (deliveryId, hashId, deliveries = [], cb = () => {}) =>
  async (dispatch) => {
    dispatch(createAction(globalTypes.IS_APPLICATION_LOADING)(true));
    const uploadPromises = [];

    const newDeliveries = [
      ...deliveries.map((item) => ({
        ...item,
        receiptImage: [],
        destinationId: item.id,
        deliveryDate: item.deliveryDate || undefined,
      })),
    ];
    deliveries.forEach((item, deliveryIndex) => {
      item.pictures.forEach((picture) => {
        const uploadPromise = FileService.upload(
          picture,
          FILE_TYPES.shipping.receipt,
        ).then((result) => {
          newDeliveries[deliveryIndex].receiptImage.push(result);
        });
        uploadPromises.push(uploadPromise);
      });
    });

    await Promise.all(uploadPromises);

    dispatch(
      pendingConfirmDeliveryWithImages(deliveryId, hashId, newDeliveries, cb),
    );
  };

export const pendingConfirmUniqueDelivery =
  (hashId, deliveryId, payload, cb = () => {}) =>
  async (dispatch, getState) => {
    dispatch(createAction(globalTypes.IS_APPLICATION_LOADING)(true));

    const newDeliveries = payload.map((item) => ({
      ...item,
      receiptImage: [],
      destinationId: item.id,
      deliveryDate: item.deliveryDate || undefined,
    }));

    const uploadPromises = [];

    payload.forEach((item, index) => {
      item.pictures.forEach((picture) => {
        const uploadPromise = FileService.upload(
          picture,
          FILE_TYPES.shipping.receipt,
        ).then((result) => {
          newDeliveries[index].receiptImage.push(result);
        });
        uploadPromises.push(uploadPromise);
      });
    });

    try {
      await Promise.all(uploadPromises);

      const { observation, receiptImage, id, deliveryDate } = newDeliveries[0];

      await LoadDetailsService.closeUniqueLoadByTransporter(
        hashId,
        deliveryId,
        {
          destinationId: id,
          receiptImage,
          observation,
          deliveryDate,
        },
      );

      cb();

      dispatch(
        createAction(globalTypes.SHOW_USER_FEEDBACK)({
          feedbackMessage: "Frete finalizado com sucesso.",
          feedbackTitle: null,
          feedbackType: "MESSAGE",
          styleFeedbackType: "success",
          messageTimestamp: new Date().getTime(),
        }),
      );

      const state = getState();
      const path = get(history, "location.pathname", "");
      const search = get(history, "location.search", ""); // aqui estava pathname nos dois, corrigi para search

      if (path.includes("/pendings")) {
        const query = getUrlSearchParams(search);
        const filter = getFiltersFromUrl(query);
        dispatch(getAllPendings({ ...filter, page: 1, targetType }));
      } else {
        const type = get(state, "pendings.pendingModal.type", "");
        const filter =
          type === "DETAIL"
            ? { status: "OPEN", notViewed: true }
            : { status: "OPEN" };
        dispatch(getAllPendings({ ...filter, page: 1, targetType }));
      }
    } catch (err) {
      console.log(err.message);
    } finally {
      dispatch(createAction(globalTypes.IS_APPLICATION_LOADING)(false));
    }
  };

export const confirmUniqueDelivery =
  (hashId, deliveryId, payload) => async (dispatch) => {
    dispatch(createAction(globalTypes.IS_APPLICATION_LOADING)(true));

    const newDeliveries = payload.map((item) => ({
      ...item,
      receiptImage: [],
      destinationId: item.id,
      deliveryDate: item.deliveryDate || undefined,
    }));

    const uploadPromises = [];

    payload.forEach((item, index) => {
      item.pictures.forEach((picture) => {
        const uploadPromise = FileService.upload(
          picture,
          FILE_TYPES.shipping.receipt,
        ).then((result) => {
          newDeliveries[index].receiptImage.push(result);
        });
        uploadPromises.push(uploadPromise);
      });
    });

    try {
      await Promise.all(uploadPromises);

      const { observation, receiptImage, id, deliveryDate } = newDeliveries[0];

      await LoadDetailsService.closeUniqueLoadByTransporter(
        hashId,
        deliveryId,
        {
          destinationId: id,
          receiptImage,
          observation,
          deliveryDate,
        },
      );

      dispatch(fetchLoadById(hashId));
    } catch (err) {
      console.log(err.message);
    } finally {
      dispatch(createAction(globalTypes.IS_APPLICATION_LOADING)(false));
    }
  };

const fetchAndProcessSvg = (path) =>
  new Promise((resolve, reject) => {
    FileService.downloadFile(path)
      .then((result) => {
        const receiptData = {
          preview: result,
          path,
          type: ".svg",
        };
        resolve(receiptData);
      })
      .catch((error) => {
        reject(error);
      });
  });

const fetchAndProcessOtherFile = (path) =>
  new Promise((resolve, reject) => {
    const receiptData = {
      preview: resourcerPrivateParse(path),
      path,
      type: `.${getFileExtension(path)}`,
    };
    resolve(receiptData);
  });

export const fetchReceiptImages =
  (paths, destinationId) => (dispatch, state) => {
    dispatch(createAction(globalTypes.IS_APPLICATION_LOADING)(true));
    dispatch(createAction(types.CLEAR_DELIVERY_RECEIPTS)(destinationId));

    if (paths) {
      const promisses = paths.map((path) => {
        const previousReceipts = get(
          state(),
          `loadsDetails.deliveryReceipts[${destinationId}]`,
          [],
        );

        if (path.endsWith(".svg")) {
          return fetchAndProcessSvg(
            path,
            previousReceipts,
            destinationId,
            dispatch,
          );
        }
        return fetchAndProcessOtherFile(
          path,
          previousReceipts,
          destinationId,
          dispatch,
        );
      });
      const processedReceipts = [];
      Promise.all(promisses)
        .then((results) => {
          results.forEach((result) => {
            if (result) {
              processedReceipts.push(result);
            }
          });
          dispatch(
            createAction(types.FETCH_LOAD_RECEIPT_BY_DELIVERY)({
              receipts: processedReceipts,
              destinationId,
            }),
          );
        })
        .finally(() =>
          dispatch(createAction(globalTypes.IS_APPLICATION_LOADING)(false)),
        );
    }
  };

export const updateReceiptImages =
  (hashId, destinationId, receiverId, paths, shippingDeliveryId) =>
  (dispatch) => {
    dispatch(createAction(globalTypes.IS_APPLICATION_LOADING)(true));
    LoadDetailsService.updateReceiptImages(
      hashId,
      destinationId,
      receiverId,
      paths,
    )
      .then(() => {
        if (shippingDeliveryId) {
          dispatch(fetchLoadById(hashId, shippingDeliveryId));
        } else {
          dispatch(fetchLoadById(hashId));
        }
        dispatch(fetchReceiptImages(paths, destinationId));
        return dispatch(
          createAction(globalTypes.SHOW_USER_FEEDBACK)({
            feedbackMessage: "Comprovate(s) atualizado(s) com sucesso.",
            feedbackTitle: null,
            feedbackType: "MESSAGE",
            styleFeedbackType: "success",
            messageTimestamp: new Date().getTime(),
          }),
        );
      })
      .catch((err) => {
        dispatch(createAction(globalTypes.IS_APPLICATION_LOADING)(false));
        console.log(err);
      });
  };

export const updateReceiptImagesWithFiles =
  (hashId, destinationId, receiverId, files = [], shippingDeliveryId) =>
  async (dispatch) => {
    dispatch(createAction(globalTypes.IS_APPLICATION_LOADING)(true));
    dispatch(createAction(types.CLEAR_DELIVERY_RECEIPTS)(receiverId));
    const newBlobs = files.filter((file) => file && file.lastModified);
    const paths = files
      .filter((file) => file && file.path)
      .map((item) => item.path);
    if (newBlobs && newBlobs.length) {
      try {
        const promises = newBlobs.map((item) =>
          FileService.upload(item, FILE_TYPES.shipping.receipt),
        );
        const result = await Promise.all(promises);
        paths.push(...result);
        dispatch(
          updateReceiptImages(
            hashId,
            destinationId,
            receiverId,
            paths,
            shippingDeliveryId,
          ),
        );
      } catch (err) {
        console.log(err);
      }
    } else {
      dispatch(
        updateReceiptImages(
          hashId,
          destinationId,
          receiverId,
          paths,
          shippingDeliveryId,
        ),
      );
    }
  };

export const removeDriveFromLoad =
  (hashId, deliveryId, driverId) => (dispatch) => {
    dispatch(createAction(globalTypes.IS_APPLICATION_LOADING)(true));
    LoadDetailsService.removeDriveFromLoad(hashId, driverId, deliveryId)
      .then(() => {
        dispatch(createAction(globalTypes.IS_APPLICATION_LOADING)(false));
        dispatch(fetchLoadById(hashId, deliveryId));
        return dispatch(
          createAction(globalTypes.SHOW_USER_FEEDBACK)({
            feedbackMessage: "Motorista removido com sucesso.",
            feedbackTitle: null,
            feedbackType: "MESSAGE",
            styleFeedbackType: "success",
            messageTimestamp: new Date().getTime(),
          }),
        );
      })
      .catch((err) => {
        dispatch(createAction(globalTypes.IS_APPLICATION_LOADING)(false));
        console.log(err.message);
      });
  };

export const ungroupShippings = (hashId) => (dispatch) => {
  dispatch(createAction(globalTypes.IS_APPLICATION_LOADING)(true));
  LoadDetailsService.ungroupShippings(hashId)
    .then(() => {
      dispatch(createAction(globalTypes.IS_APPLICATION_LOADING)(false));
      dispatch(fetchLoadById(hashId));
      return dispatch(
        createAction(globalTypes.SHOW_USER_FEEDBACK)({
          feedbackMessage: "Frete desagrupado com sucesso.",
          feedbackTitle: null,
          feedbackType: "MESSAGE",
          styleFeedbackType: "success",
          messageTimestamp: new Date().getTime(),
        }),
      );
    })
    .catch((err) => {
      dispatch(createAction(globalTypes.IS_APPLICATION_LOADING)(false));
      console.log(err);
    });
};
export const ungroupSingleGroupAction = (hashId, deliveryId) => (dispatch) => {
  dispatch(createAction(globalTypes.IS_APPLICATION_LOADING)(true));
  LoadDetailsService.ungroupSingleShipping(hashId, deliveryId)
    .then(() => {
      dispatch(createAction(globalTypes.IS_APPLICATION_LOADING)(false));
      dispatch(fetchLoadById(hashId));
      return dispatch(
        createAction(globalTypes.SHOW_USER_FEEDBACK)({
          feedbackMessage: "Frete desagrupado com sucesso.",
          feedbackTitle: null,
          feedbackType: "MESSAGE",
          styleFeedbackType: "success",
          messageTimestamp: new Date().getTime(),
        }),
      );
    })
    .catch((err) => {
      dispatch(createAction(globalTypes.IS_APPLICATION_LOADING)(false));
      console.log(err);
    });
};
export const addGroupAction = (hashId, deliveryIds) => (dispatch) => {
  dispatch(createAction(globalTypes.IS_APPLICATION_LOADING)(true));
  LoadDetailsService.addGroup(hashId, deliveryIds)
    .then(() => {
      dispatch(createAction(globalTypes.IS_APPLICATION_LOADING)(false));
      dispatch(fetchLoadById(hashId));
      return dispatch(
        createAction(globalTypes.SHOW_USER_FEEDBACK)({
          feedbackMessage: "Frete agrupado com sucesso.",
          feedbackTitle: null,
          feedbackType: "MESSAGE",
          styleFeedbackType: "success",
          messageTimestamp: new Date().getTime(),
        }),
      );
    })
    .catch((err) => {
      dispatch(createAction(globalTypes.IS_APPLICATION_LOADING)(false));
      console.log(err);
    });
};

export const getMapboxDirections =
  (locations, waypoints, hashId, type) => (dispatch) => {
    dispatch(createAction(globalTypes.IS_APPLICATION_LOADING)(true));
    MapboxService.getMapboxDirections(locations, waypoints)
      .then((result) => {
        dispatch(
          createAction(globalTypes.MAPBOX_DIRECTIONS_RESPONSE)({
            [type]: { ...result, hashId },
          }),
        );
        dispatch(createAction(globalTypes.IS_APPLICATION_LOADING)(false));
      })
      .catch((err) => {
        dispatch(createAction(globalTypes.IS_APPLICATION_LOADING)(false));
        console.log(err);
      });
  };

export const deleteFilesToLoad =
  (hashId, attachmentId, deliveryId) => (dispatch) => {
    LoadDetailsService.deleteFilesToLoad(hashId, attachmentId)
      .then(() => {
        dispatch(createAction(globalTypes.IS_APPLICATION_LOADING)(false));
        dispatch(
          createAction(globalTypes.SHOW_USER_FEEDBACK)({
            feedbackMessage: "Arquivos deletado com sucesso.",
            feedbackTitle: null,
            feedbackType: "MESSAGE",
            styleFeedbackType: "success",
            messageTimestamp: new Date().getTime(),
          }),
        );
        return dispatch(fetchLoadAttachments(hashId, deliveryId));
      })
      .catch((err) => {
        dispatch(createAction(globalTypes.IS_APPLICATION_LOADING)(false));
        console.log(err);
      });
  };

const attachmentsPayload = (attachments) =>
  Promise.all(
    attachments.map((attachment) => {
      if (typeof attachment !== "string") {
        return FileService.upload(attachment, FILE_TYPES.shipping.document);
      }
      return Promise.resolve(attachment);
    }),
  );

export const updateFilesToLoad =
  (hashId, attachments = [], observation, type, attachmentId, deliveryId) =>
  async (dispatch) => {
    try {
      const payloadAttachments = await attachmentsPayload(attachments);
      const payload = {
        attachments: [...payloadAttachments],
        description: observation,
        type,
        shippingDeliveryId: deliveryId,
      };

      LoadDetailsService.updateFilesToLoad(hashId, payload, attachmentId)
        .then(() => {
          dispatch(
            createAction(globalTypes.SHOW_USER_FEEDBACK)({
              feedbackMessage: "Anexos atualizado com sucesso.",
              feedbackTitle: null,
              feedbackType: "MESSAGE",
              styleFeedbackType: "success",
              messageTimestamp: new Date().getTime(),
            }),
          );
          return dispatch(fetchLoadAttachments(hashId, deliveryId));
        })
        .catch((err) => {
          console.log(err);
        })
        .finally(() =>
          dispatch(createAction(globalTypes.IS_APPLICATION_LOADING)(false)),
        );
    } catch (err) {
      console.log(err);
    }
  };

export const attachFilesToLoad =
  (hashId, paths, observation, type, deliveryId) => (dispatch) => {
    const payload = {
      attachments: [...paths],
      description: observation,
      type,
      shippingDeliveryId: deliveryId,
    };
    LoadDetailsService.attachFilesToLoad(hashId, payload)
      .then(() => {
        dispatch(createAction(globalTypes.IS_APPLICATION_LOADING)(false));
        dispatch(
          createAction(globalTypes.SHOW_USER_FEEDBACK)({
            feedbackMessage: "Arquivos anexados a carga com sucesso.",
            feedbackTitle: null,
            feedbackType: "MESSAGE",
            styleFeedbackType: "success",
            messageTimestamp: new Date().getTime(),
          }),
        );
        return dispatch(fetchLoadAttachments(hashId, deliveryId));
      })
      .catch((err) => {
        dispatch(createAction(globalTypes.IS_APPLICATION_LOADING)(false));
        console.log(err);
      });
  };

export const uploadAttachments =
  (hashId, attachments = [], observation, type, deliveryId) =>
  async (dispatch) => {
    dispatch(createAction(globalTypes.IS_APPLICATION_LOADING)(true));
    try {
      const promises = attachments.map((item) =>
        FileService.upload(item, FILE_TYPES.shipping.document),
      );
      const paths = await Promise.all(promises);
      dispatch(attachFilesToLoad(hashId, paths, observation, type, deliveryId));
    } catch (err) {
      console.log(err);
    } finally {
      dispatch(createAction(globalTypes.IS_APPLICATION_LOADING)(false));
    }
  };

export const fetchLogisticOperators = (operationGroupId) => (dispatch) => {
  dispatch(createAction(globalTypes.IS_APPLICATION_LOADING)(true));
  LoadDetailsService.fetchLogisticOperators(operationGroupId)
    .then((result) =>
      dispatch(createAction(types.FETCH_LOGISTIC_OPERATORS)(result)),
    )
    .catch((err) => console.log(err))
    .finally(() =>
      dispatch(createAction(globalTypes.IS_APPLICATION_LOADING)(false)),
    );
};

export const confirmSendToLogisticOperator =
  (hashId, deliveryId, sendToLogisticOperatorRequest) => async (dispatch) => {
    dispatch(createAction(globalTypes.IS_APPLICATION_LOADING)(true));

    const {
      attachments,
      logisticOperatorId,
      occurrenceObservation,
      occurrenceType,
    } = sendToLogisticOperatorRequest;

    try {
      let attachmentsPaths = [];

      if (attachments && attachments.length > 0) {
        attachmentsPaths = await Promise.all(
          attachments.map((item) =>
            FileService.upload(item, FILE_TYPES.shipping.document),
          ),
        );
      }

      await LoadDetailsService.confirmSendToLogisticOperator(
        hashId,
        deliveryId,
        {
          attachments: attachmentsPaths,
          logisticOperatorId,
          occurrenceObservation,
          occurrenceType,
        },
      );

      dispatch(fetchLoadById(hashId));
    } catch (err) {
      console.log(err);
    } finally {
      dispatch(createAction(globalTypes.IS_APPLICATION_LOADING)(false));
    }
  };

export const pendingConfirmSendToLogisticOperator =
  (hashId, deliveryId, sendToLogisticOperatorRequest, cb) =>
  async (dispatch, getState) => {
    dispatch(createAction(globalTypes.IS_APPLICATION_LOADING)(true));

    const {
      attachments,
      logisticOperatorId,
      occurrenceObservation,
      occurrenceType,
    } = sendToLogisticOperatorRequest;

    try {
      let attachmentsPaths = [];

      if (attachments && attachments.length > 0) {
        attachmentsPaths = await Promise.all(
          attachments.map((item) =>
            FileService.upload(item, FILE_TYPES.shipping.document),
          ),
        );
      }

      await LoadDetailsService.confirmSendToLogisticOperator(
        hashId,
        deliveryId,
        {
          attachments: attachmentsPaths,
          logisticOperatorId,
          occurrenceObservation,
          occurrenceType,
        },
      );

      cb();

      const state = getState();
      const path = get(history, "location.pathname", "");
      const search = get(history, "location.search", "");

      if (path.includes("/pendings")) {
        const query = getUrlSearchParams(search);
        const filter = getFiltersFromUrl(query);
        dispatch(getAllPendings({ ...filter, page: 1, targetType }));
      } else {
        const type = get(state, "pendings.pendingModal.type", "");
        const filter =
          type === "DETAIL"
            ? { status: "OPEN", notViewed: true }
            : { status: "OPEN" };
        dispatch(getAllPendings({ ...filter, page: 1, targetType }));
      }
    } catch (err) {
      console.log(err);
    } finally {
      dispatch(createAction(globalTypes.IS_APPLICATION_LOADING)(false));
    }
  };

export const downloadShippingOnOperator =
  (hashId, deliveryId) => (dispatch) => {
    dispatch(createAction(globalTypes.IS_APPLICATION_LOADING)(true));
    LoadDetailsService.downloadShippingOnOperator(hashId, deliveryId)
      .then(() => {
        dispatch(createAction(globalTypes.IS_APPLICATION_LOADING)(false));
        dispatch(
          createAction(globalTypes.SHOW_USER_FEEDBACK)({
            feedbackMessage: "Carga descarregada no operador com sucesso.",
            feedbackTitle: null,
            feedbackType: "MESSAGE",
            styleFeedbackType: "success",
            messageTimestamp: new Date().getTime(),
          }),
        );
        dispatch(fetchLoadById(hashId, deliveryId));
      })
      .catch((err) => {
        dispatch(createAction(globalTypes.IS_APPLICATION_LOADING)(false));
        console.log(err);
      })
      .finally(() =>
        dispatch(createAction(globalTypes.IS_APPLICATION_LOADING)(false)),
      );
  };
export const changeVehicleToBind = (vehicle) => (dispatch) => {
  dispatch(createAction(types.CHANGE_VEHICLE_TO_BIND)(vehicle));
};

export const handleUpdateVehicle =
  ({ id, data, plate, toBind = () => {}, hashId, deliveryId }) =>
  (dispatch) => {
    dispatch(createAction(globalTypes.IS_APPLICATION_LOADING)(true));
    NewFleetServices.updateVehicle(id, data)
      .then(() => {
        toBind(null, data);
        dispatch(findVehicleByPlate(plate, hashId, deliveryId));
      })
      .catch((err) => console.log(err.message))
      .finally(() =>
        dispatch(createAction(globalTypes.IS_APPLICATION_LOADING)(false)),
      );
  };

export const fetchLoadDetail =
  ({ hashId, deliveryId }) =>
  (dispatch, state) => {
    return LoadDetailsService.fetchLoadDetailsById(hashId, deliveryId)
      .then((result) => {
        if (result) {
          const { flEnableTrackingDevice, deliveryHash, shipper } = result;
          dispatch(
            createAction(types.HANDLE_ENABLE_TRACKING_DEVICE)({
              flEnableCommunication: shipper?.flEnableCommunication,
              flEnableTrackingDevice,
              deliveryHash,
            }),
          );
          return result;
        }
      })
      .catch((err) => console.log(err));
  };
export const handleTrackerInformation = () => (dispatch) => {
  dispatch(
    createAction(globalTypes.SHOW_USER_FEEDBACK)({
      feedbackMessage: "Por favor adicione os dados do rastreador!",
      feedbackTitle: "Não foi possível.",
      feedbackType: "NOTIFICATION",
      styleFeedbackType: "error",
      messageTimestamp: new Date().getTime(),
    }),
  );
};
export const handleTrackingDeviceFields = (value, primary) => (dispatch) => {
  dispatch(
    createAction(types.MAPPED_TRACKING_DEVICE_FIELDS)({
      id: value.id,
      data: value,
      primary,
    }),
  );
};
export const onTrackingDeviceFields =
  (id, addTracking, justify) => (dispatch) => {
    dispatch(
      createAction(types.CHANGE_TRACKING_DEVICE_FIELDS)({
        id,
        addTracking,
        justify,
      }),
    );
  };
export const clearTrackingDeviceFields = () => (dispatch) => {
  dispatch(createAction(types.CLEAR_TRACKING_DEVICE_FIELDS)());
};
export const handleWithMissingTracker =
  (id, payload, toBind = () => {}) =>
  (dispatch) => {
    LoadDetailsService.sendDoesntHaveATracker(id, payload).then((res) => {
      toBind();
      dispatch(onTrackingDeviceFields(id, true, ""));
    });
  };

export const requestReopen = (hashId, reason, cb) => (dispatch) => {
  dispatch(createAction(globalTypes.IS_APPLICATION_LOADING)(true));
  LoadDetailsService.requestReopen(hashId, reason)
    .then((r) => {
      if (!r && cb) {
        cb();
      }
    })
    .catch((err) => console.log(err.message))
    .finally(() =>
      dispatch(createAction(globalTypes.IS_APPLICATION_LOADING)(false)),
    );
};

export const getAllPendingsByShipping = (deliveryId) => (dispatch) => {
  dispatch(createAction(globalTypes.IS_APPLICATION_LOADING)(true));
  LoadDetailsService.getAllPendingsByShipping(deliveryId)
    .then(({ data, status }) => {
      if (status === 200) {
        return dispatch(createAction(types.GET_ALL_PENDINGS_BY_SHIPPING)(data));
      }
      return dispatch(createAction(types.GET_ALL_PENDINGS_BY_SHIPPING)([]));
    })
    .finally(() =>
      dispatch(createAction(globalTypes.IS_APPLICATION_LOADING)(false)),
    );
};
export const getAllPendingsTypes = (deliveryId) => (dispatch) => {
  dispatch(createAction(globalTypes.IS_APPLICATION_LOADING)(true));
  LoadDetailsService.getAllPendingsTypes(deliveryId)
    .then(({ data, status }) => {
      if (status === 200) {
        dispatch(createAction(types.GET_ALL_PENDINGS_TYPES)(data));
      }
    })
    .finally(() =>
      dispatch(createAction(globalTypes.IS_APPLICATION_LOADING)(false)),
    );
};
export const createNewPending =
  (payload, hashId, cb = () => {}) =>
  (dispatch) => {
    dispatch(createAction(globalTypes.IS_APPLICATION_LOADING)(true));
    LoadDetailsService.createNewPending(payload)
      .then(({ data, status }) => {
        if (status === 200) {
          cb();
          dispatch(getAllPendingsByShipping(payload.shippingDeliveryId));
          dispatch(
            createAction(globalTypes.SHOW_USER_FEEDBACK)({
              feedbackMessage: "Pendência criada com sucesso",
              feedbackTitle: null,
              feedbackType: "MESSAGE",
              styleFeedbackType: "success",
              messageTimestamp: new Date().getTime(),
            }),
          );
          dispatch(fetchLoadById(hashId, payload.shippingDeliveryId));
        }
      })
      .catch((err) => console.log(err))
      .finally(() =>
        dispatch(createAction(globalTypes.IS_APPLICATION_LOADING)(false)),
      );
  };
export const removePending =
  ({ id, deliveryId, hashId }) =>
  (dispatch) => {
    dispatch(createAction(globalTypes.IS_APPLICATION_LOADING)(true));
    LoadDetailsService.removePending(id)
      .then(({ data, status }) => {
        if (status === 200) {
          dispatch(getAllPendingsByShipping(deliveryId));
          dispatch(
            createAction(globalTypes.SHOW_USER_FEEDBACK)({
              feedbackMessage: "Pendência removida com sucesso",
              feedbackTitle: null,
              feedbackType: "MESSAGE",
              styleFeedbackType: "success",
              messageTimestamp: new Date().getTime(),
            }),
          );
          dispatch(fetchLoadById(hashId, deliveryId));
        }
      })
      .catch((err) => console.log(err))
      .finally(() =>
        dispatch(createAction(globalTypes.IS_APPLICATION_LOADING)(false)),
      );
  };

export const togglePendingDrawerVisible = () => (dispatch) => {
  dispatch(createAction(types.TOGGLE_PENDING_DRAWER_VISIBLE)({}));
};

function pause(msec) {
  return new Promise((resolve) => {
    setTimeout(resolve, msec || 1000);
  });
}

async function downloadFilesWithPause(allFiles, cb) {
  const batchSize = 10;
  const totalFiles = allFiles.length;

  for (let i = 0; i < totalFiles; i += batchSize) {
    const batch = allFiles.slice(i, i + batchSize);

    for (const file of batch) {
      saveAs(file.preview, file.name);
    }

    if (typeof cb === "function" && i + batchSize >= totalFiles) {
      cb();
    }
    if (i + batchSize < totalFiles) {
      await pause(1000);
    }
  }
}

export const downloadAllFiles = (files, cb) => (dispatch) => {
  if (files && files.length) {
    dispatch(
      createAction(globalTypes.SHOW_USER_FEEDBACK)({
        feedbackMessage: "Preparando os anexos.",
        feedbackTitle: null,
        feedbackType: "MESSAGE",
        styleFeedbackType: "info",
        messageTimestamp: new Date().getTime(),
      }),
    );
    Promise.all(files.map((path) => FileService.downloadFile(path)))
      .then((results) => {
        const allFiles = results.map((result, index) => {
          const path = files[index];
          const fileTypeIdx = path.lastIndexOf(".");
          const fileType = path.slice(fileTypeIdx);
          return {
            preview: result,
            type: fileType,
            name: path.slice(path.lastIndexOf("/") + 1),
          };
        });
        downloadFilesWithPause(allFiles, () => {
          if (typeof cb === "function") {
            cb();
          }
          dispatch(
            createAction(globalTypes.SHOW_USER_FEEDBACK)({
              feedbackMessage: "Os anexos foram baixados!",
              feedbackTitle: null,
              feedbackType: "MESSAGE",
              styleFeedbackType: "success",
              messageTimestamp: new Date().getTime(),
            }),
          );
        });
      })
      .catch((error) => {
        console.error("Erro ao baixar os arquivos:", error);
        dispatch(
          createAction(globalTypes.SHOW_USER_FEEDBACK)({
            feedbackMessage: "Não foi possível realizar o download!",
            feedbackTitle: null,
            feedbackType: "MESSAGE",
            styleFeedbackType: "error",
            messageTimestamp: new Date().getTime(),
          }),
        );
      })
      .finally(() => {
        if (typeof cb === "function") {
          cb();
        }
      });
  }
};

export const clearDriverToBind = () => (dispatch) =>
  dispatch(createAction(types.CLEAR_DRIVER_TO_BIND)());
export const clearVehicleToBind = () => (dispatch) =>
  dispatch(createAction(types.CLEAR_VEHICLE_TO_BIND)());

export const getOrderDetailsByCode = (orderCode, shipperId) => (dispatch) => {
  dispatch(createAction(types.ORDER_IS_LOADING)(true));
  LoadDetailsService.findOrderByCode(orderCode, shipperId)
    .then((res) => {
      if (res.ok) {
        dispatch(createAction(types.SELECT_ORDER_BY_CODE)(res.data));
      }
    })
    .finally(() => dispatch(createAction(types.ORDER_IS_LOADING)(false)));
};

export const removeSelectedOrder = () => (dispatch) => {
  dispatch(createAction(types.SELECT_ORDER_BY_CODE)(false));
};

export const getShippingOrder = (payload, callback) => (dispatch) => {
  dispatch(createAction(globalTypes.REPORT_GENERATION_IS_LOADING)(true));
  LoadDetailsService.getShippingOrder(payload).then((res) => {
    if (!res.ok) {
      dispatch(clearReportProgress());
      notification.close("report");
      if (callback) {
        callback();
      }
    }
  });
};

const throwIfApiNotOk = (res) => {
  if (res.ok) return res;
  const msg = res.data?.message || res.data?.error || res.problem;
  throw new Error(typeof msg === "string" ? msg : "Falha na operação.");
};

export const saveDataCiot = (deliveryId, payload) => (dispatch) => {
  dispatch(createAction(globalTypes.IS_APPLICATION_LOADING)(true));
  return LoadDetailsService.saveDataCiot(deliveryId, payload)
    .then((res) => {
      dispatch(createAction(globalTypes.IS_APPLICATION_LOADING)(false));
      return throwIfApiNotOk(res);
    })
    .catch((err) => {
      dispatch(createAction(globalTypes.IS_APPLICATION_LOADING)(false));
      if (err instanceof Error && err.message) {
        throw err;
      }
      const apiMessage =
        err?.response?.data?.message || err?.response?.data?.error;
      if (apiMessage) {
        throw new Error(
          typeof apiMessage === "string" ? apiMessage : String(apiMessage),
        );
      }
      throw err;
    })
    .finally(() => {
      dispatch(createAction(globalTypes.IS_APPLICATION_LOADING)(false));
    });
};
